<!--
 * @Author: zxf
 * @Date: 2022-07-26 10:20:56
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 17:44:38
 * @Description: 维保计划列表
-->
<template>
  <div
    v-loading="loading"
    class="l-page--inner l-page--detail"
  >
    <!-- <div
      v-if="type==='wbjhManage'"
      class="u-mg-b-10"
    >
      <k-button
          btn-text="导出"
:auth-type="false"
        type="success"
        icon="kestrel-icon ki-plus"
        @click="handleDialog('add', {dlType: 'add'})"
      >
        新增
      </k-button>
    </div> -->

    <k-table-infinite
      v-loading="loading"
      :infinite-scroll-disabled="isDisabled"
      :infinite-scroll-immediate="false"
      height="750px"
      :table-column="tableColumn"
      :data="page.rows"
      :pagination="page"
      @current-change="search"
      @size-change="handleSizeChange"
    >
      <template
        #jhmc="scope"
      >
        <el-link
          type="primary"
          @click="openNavTab({ name: 'viewWbjh', params: { id: scope.row.id } })"
        >
          {{ scope.row.jhmc }}
        </el-link>
      </template>

      <template
        #qzrq="scope"
      >
        {{ scope.row.jhsjQ || '-' | date("yyyy-MM-dd") }} 至 {{ scope.row.jhsjZ || '-' | date("yyyy-MM-dd") }}
      </template>

      <el-table-column
        v-if="type==='wbjhManage'"
        prop="enabled"
        label="操作"
        width="120"
        align="center"
        fixed="right"
      >
        <template
          slot-scope="scope"
        >
          <k-button
            btn-text="编辑"
            :auth-type="true"
            type="primary"
            plain
            @click="handleDialog('edit', {dlType: 'edit', id: scope.row.id})"
          />
          <k-button
            btn-text="删除"
            :auth-type="true"
            type="danger"
            @click="handleDel(scope.row, scope.$index)"
          />
        </template>
      </el-table-column>
    </k-table-infinite>
    <!-- 页面主内容：查询列表 End -->
    <!-- 新增/修改维保计划信息 -->
    <wbjh-update-dialog
      v-if="showDialogName==='add' || showDialogName==='edit'"
      :dl-params="dialogParams"
      @callback="refreshSearch()"
      @closeDialog="handleDialog"
    />
  </div>
</template>
<script>
import WbjhUpdateDialog from '../wbjh/updateDialog.vue';
import { wbjhService } from '../wbjh/wbjh.service';
export default {
  name: 'WbjhList',
  components: {
    WbjhUpdateDialog
  },
  props: {
    type: {
      type: String,
      default: 'wbjhList'
    }
  },
  data () {
    return {
      loading: false, // 页面是否loading状态

      xmId: null, // 项目编码
      isMore: false, // 更多标志
      isDisabled: false, // 可不用标志
      loadedPageNo: 0, // 已加载页码

      /* 查询条件（页面绑定的查询条件） start */
      filterParams: {
        xmId: null
      },
      /* 查询条件 end */

      /* 查询条件（页面绑定的查询条件） start */
      trueFilterParams: { },
      /* 查询条件 end */

      /* 查询结果 Start */
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      },
      /* 查询结果 End */

      /* 表格列配置Start */
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'xmmc', label: '项目名称', align: 'left', minWidth: '120', type: 'text' },
        { key: 'jhmc', slotName: 'jhmc', label: '计划名称', align: 'left', minWidth: '120', type: 'text' },
        { key: 'qzrq', slotName: 'qzrq', label: '计划起止日期', align: 'center', width: '200', type: 'date' },
        { key: 'jhztMc', label: '计划状态', align: 'left', width: '100', type: 'text' },
        // { key: 'lrdwMc', label: '录入单位', align: 'left', width: '200', type: 'text' },
        { key: 'cjsj', label: '创建时间', align: 'center', width: '140', type: 'dateTime' }
      ],
      /* 表格列配置End */

      /* 弹窗 Start */
      showDialogName: '',
      dialogParams: {}
      /* 弹窗 End */
    };
  },
  methods: {
    getDataNextPage () {
      if (this.loadedPageNo === this.page.pageNo + 1) {
      } else if (this.loadedPageNo !== this.page.pageNo + 1 && this.page.pageNo < this.page.totalPages) {
        this.isMore = true;
        this.isDisabled = false;
        this.search(this.page.pageNo + 1);
      } else {
        this.isMore = false;
        this.isDisabled = true;
      }
    },
    /**
     * @description: 通用显示模态框dialog组件
     * @param {String} _name 显示的模态框dialog名称
     * @param {Object} _params 模态框dialog传入参数
     * @return {*}
     */
    handleDialog (_name, _parmas) {
      this.showDialogName = _name;
      this.dialogParams = _parmas;
    },
    /**
     * @description: 记录分页查询条件，调用查询方法
     * @return {*}
     */
    refreshSearch () {
      this.page.rows = [];
      this.page.pageNo = 0;
      this.page.totalPages = 0;
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      this.search();
    },
    /**
     * @description: 分页切换大小
     * @param {number} val
     * @return {*}
     */
    handleSizeChange (val) {
      this.page.pageSize = val;
      this.search();
    },
    /**
     * @description: 查询列表方法
     * @param {number} _pageNo
     * @return {*}
     */
    search (_pageNo = 1) {
      const _this = this;
      /* 处理分页参数 Start */
      _this.trueFilterParams.pageSize = _this.page.pageSize;
      _this.trueFilterParams.pageNo = _pageNo;
      /* 处理分页参数 End */
      _this.loading = true;
      // 重置数据数组
      this.page.rows = [];

      wbjhService.query(_this.trueFilterParams)
        .then(rsp => {
          _this.page.pageNo = rsp.data.pageNo;
          _this.page.totalPages = rsp.data.totalPages;
          _this.page.total = rsp.data.total;
          _this.page.rows = _this.page.rows.concat(rsp.data.rows);

          console.log('search', _this.page);
          // 导出条件更新为查询使用的条件
          _this.exportFilterParams = JSON.parse(JSON.stringify(this.trueFilterParams));
          if (_this.page.pageNo < _this.page.totalPages) {
            _this.isMore = true;
          }
        })
        .catch(err => {
          console.error('查询错误！', err);
        })
        .finally(() => {
          _this.loading = false;
        });
    },
    /**
     * @description: 删除
     * @return {*}
     */
    handleDel (_row) {
      const _this = this;
      _this.$confirm(`是否确认删除此计划：${_row.xmmc}？`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        wbjhService.delete(_row.id)
          .then(rsp => {
            _this.$alert('删除成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
              }
            });
            _this.refreshSearch();
          })
          .catch(err => {
            console.error('删除失败！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    }
  },
  created () {
    this.xmId = this.$route.params.xmId;
    this.filterParams.xmId = this.xmId;
    this.refreshSearch();
  }

};
</script>
